import React from 'react';
import {
  SecSubTitle,
  SecTitle,
  ProgressOne
} from '../../components';

const AboutTwo = ({...restProps})=> (
  <div {...restProps}>
    <div className="container">
      <div className="row flex-row-reverse">
        <div className="col-lg-5 col-xxl-auto mb-30 pb-20 pb-lg-0">
          <img src="images/bg/pc-min.png" alt="Skill"/>
        </div>
        <div className="col-lg-7 col-xxl-6 me-xl-auto">
          <SecSubTitle><i className="fas fa-bring-forward"/>The Great Company Skill</SecSubTitle>
          <SecTitle className="h1">Empowering Institutions with Smart Technology</SecTitle>
          <p className="mb-4 pb-1">We bridge the gap between people and technology by delivering tailor-made digital solutions for educational institutions and businesses. Our focus on innovation, security, and professional development drives measurable impact for our clients across Africa and beyond....</p>
          <ProgressOne title="Cybersecurity & Infrastructure" now={99}/>
          <ProgressOne title="Professional & Career Development" now={99}/>
          <ProgressOne title="Business Innovation & Automation" now={95}/>
        </div>
      </div>
    </div>
  </div>
);

export default AboutTwo;